import { defineNuxtPlugin } from '#app'
import {Centrifuge} from 'centrifuge';

export default defineNuxtPlugin(nuxtApp => {
    // Створюємо інстанс, але не викликаємо .connect() прямо тут
    const centrifuge = new Centrifuge(nuxtApp.$config.public.centrifugoEndpoint, {
        debug: Boolean(nuxtApp.$config.public.centrifugoDebug || false)
    })

    const {markServerReachable, markRealtimeLost} = useConnectionStatus()
    // Перше підключення теж іде через 'connecting' — розривом вважаємо лише втрату вже живого з'єднання
    let wasConnected = false

    centrifuge.on('connecting', (ctx) => {
        console.debug('[centrifuge] Connecting to Centrifuge', ctx)
        if (wasConnected) markRealtimeLost()
    })

    centrifuge.on('connected', ctx => {
        console.debug('[centrifuge] Connected to Centrifuge', ctx)
        wasConnected = true
        markServerReachable()
    })

    centrifuge.on('disconnected', ctx => {
        console.debug('[centrifuge] Disconnected of Centrifuge', ctx)
        // Свідоме відключення (вихід) чи фатальна помилка — далі не перепідключаємось, тож і
        // «розрив» не тримаємо: зв'язок з API відстежить useApi
        wasConnected = false
        markServerReachable()
    })

    return {
        provide: {
            centrifuge
        }
    }
})
